module.exports = __webpack_public_path__ + "img/fashion_40.a439eec8.jpg";